import React from 'react';
import { useOnboardingJourney } from '../../../Data/Onboarding';
import Icon from '../../../Components/Icons/Icon';
import { usePreference } from '../../../Data/Preference';
import { useDialogues } from '../../../Components/Dialogues';
import { useRedirect } from '../../../Services/helpers';

const GetStarted = () => {
    const {journey} = useOnboardingJourney(true);
    const {confirm} = useDialogues();
    const [hideGettingStarted, setHideGettingStarted] = usePreference('home:hideGettingStarted', false);
    const {go} = useRedirect();

    if (hideGettingStarted || !journey) {
        return null;
    }

    if (journey?.progress?.availableSteps === 0) {
        return null;
    }

    return <div className="relative flex flex-col gap-4 rounded-lg shadow-md p-4 text-white bg-gradient-to-br from-brand-light to-brand text-center"
        onClick={() => go('/help/checklist')}
    >
        <div className="absolute top-2 right-2">
            <Icon icon="CircleX"
                theme="solid"
                size="1x"
                className="fill-white/50"
                onClick={() => confirm(
                    {
                        theme: 'primary',
                        title: 'Hide getting started?',
                        message: 'These help options are always available in the More tab.',
                        confirmLabel: 'Hide',
                    },
                    () => setHideGettingStarted(true)
                )}
            />
        </div>

        <h1 className="text-2xl font-bold">Let's get started</h1>

        <p>Getting started with getSoapy is easy. We'll walk you through the process step by step.</p>

        <div className="h-2 bg-white/40 w-[80%] mx-auto rounded-full overflow-hidden">
            <div className="h-full bg-white rounded-full" style={{width: `${journey?.progress?.percent}%`}}>
                &nbsp;
            </div>
        </div>

        <p className="">
            {journey?.progress?.description}
        </p>
    </div>
}

export default GetStarted;
